import { useSortable } from "@dnd-kit/sortable";
import { EditOutlined, DeleteOutlined, DragOutlined, OrderedListOutlined } from "@ant-design/icons";
import React, { useRef } from "react";
import { Button, Card, Popconfirm, Space } from "antd";
import YouTube from "react-youtube";

function Sortable(props) {
  const { item, keys, onEdit, onDelete, onReorderImages } = props;
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id });
  const dragHandleRef = useRef(null);

  const style = {
    transform: `translate3d(${transform?.x || 0}px, ${transform?.y || 0}px, 0)`,
    transition,
    display: "flex",
    border: "1px solid #c8c8c8",
    padding: "8px",
    margin: "4px",
    color: "#000",
    borderRadius: "12px"
  };

  const cellStyle = {
    flex: 1,
    padding: "4px",
  };

  const editClicked = (record) => {
    onEdit(record);
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      {keys.map((key) => (
        <div key={item.id} style={cellStyle}>
          {key === "link" ? (
            <a
              href={item[key]}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "black" }}
            >
              {item[key]}
            </a>
          ) : key === "video_id" ? (
            <Card>
              <YouTube
                videoId={item[key]}
                id={item[key]}
                opts={{
                  height: "195",
                  width: "100%",
                  playerVars: {
                    rel: 0,
                  },
                }}
              />
            </Card>
          ) : (
            item[key]
          )}
        </div>
      ))}
      <Space style={{ display: "flex", alignItems: "center" }}>
        <Button
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            editClicked(item);
          }}
        >
          <EditOutlined />
        </Button>
        <Popconfirm
          title="Delete"
          description={`Are you sure to delete this?`}
          onConfirm={(e) => {
            e.stopPropagation();
            onDelete(item);
          }}
          trigger={"click"}
          placement="bottom"
        >
          <Button size="small" onClick={(e) => e.stopPropagation()}>
            <DeleteOutlined />
          </Button>
        </Popconfirm>

        {onReorderImages && (
          <Button
            size="small"
            onClick={(e) => { e.stopPropagation(); onReorderImages(item); }}
          >
            <OrderedListOutlined /> Reorder Images
          </Button>
        )}
        <Button
          type="primary"
          style={{ cursor: "grab", marginLeft: 8 }}
          ref={dragHandleRef}
          {...listeners}
        >
          <DragOutlined />
          Click here to move
        </Button>
      </Space>
    </div>
  );
}

export default Sortable;
